<template>
  <main class="legal-page py-4 py-md-5">
    <b-container>
      <b-button
        variant="flat-primary"
        class="legal-back-button mb-2"
        @click="goBack"
      >
        ← Geri
      </b-button>
      <header class="legal-page__header text-center mb-4">
        <b-link
          class="legal-page__brand"
          :to="homeTarget"
        >
          DİKO
        </b-link>
        <h1 class="mt-2 mb-1">
          Bilgilendirme Metinleri
        </h1>
        <p class="text-muted mb-0">
          Yasal metinlere ve kişisel verilerin korunmasına ilişkin belgelere buradan ulaşabilirsiniz.
        </p>
      </header>

      <b-row class="align-items-stretch">
        <b-col
          v-for="group in groups"
          :key="group.key"
          lg="4"
          class="mb-2"
        >
          <b-card class="h-100 legal-group-card">
            <h2 class="h4 mb-2">
              {{ group.title }}
            </h2>
            <ol class="legal-document-list pl-0 mb-0">
              <li
                v-for="document in documentsFor(group.key)"
                :key="document.key"
                class="legal-document-list__item"
              >
                <b-link
                  v-if="isPublished(document)"
                  :to="{ name: 'legal-document', params: { slug: document.slug } }"
                  class="legal-document-list__link"
                >
                  {{ document.title }}
                  <span aria-hidden="true">→</span>
                </b-link>
                <div
                  v-else
                  class="legal-document-list__unavailable"
                  :title="document.unavailableReason"
                >
                  <span>{{ document.title }}</span>
                  <b-badge
                    variant="light-secondary"
                    class="ml-1"
                  >
                    Henüz yayımlanmadı
                  </b-badge>
                </div>
              </li>
            </ol>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </main>
</template>

<script>
import {
  BBadge,
  BButton,
  BCard,
  BCol,
  BContainer,
  BLink,
  BRow,
} from 'bootstrap-vue'
import {
  LEGAL_GROUPS,
  getDocumentsForGroup,
  isPublishedLegalDocument,
} from '@/legal/documentRegistry'

export default {
  name: 'LegalHub',
  components: {
    BBadge,
    BButton,
    BCard,
    BCol,
    BContainer,
    BLink,
    BRow,
  },
  computed: {
    groups() {
      return [...LEGAL_GROUPS].sort((left, right) => left.order - right.order)
    },
    homeTarget() {
      return { name: 'home' }
    },
  },
  methods: {
    documentsFor: getDocumentsForGroup,
    isPublished: isPublishedLegalDocument,
    goBack() {
      if (window.history.length > 1) {
        this.$router.go(-1)
        return
      }
      this.$router.push(this.homeTarget)
    },
  },
}
</script>

<style lang="scss">
.legal-page {
  min-height: calc(100vh - 86px);
  background: #f8f8fb;
}

.legal-page__header {
  max-width: 760px;
  margin-right: auto;
  margin-left: auto;
}

.legal-page__brand {
  font-size: 1.35rem;
  font-weight: 700;
  letter-spacing: 0.08em;
}

.legal-group-card {
  border: 0;
  box-shadow: 0 6px 24px rgba(34, 41, 47, 0.08);
}

.legal-document-list {
  list-style: none;
}

.legal-document-list__item + .legal-document-list__item {
  border-top: 1px solid #ebe9f1;
}

.legal-document-list__link,
.legal-document-list__unavailable {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 1rem 0;
  gap: 0.75rem;
}

.legal-document-list__unavailable {
  color: #82868b;
}

.legal-document-list__link span {
  flex: 0 0 auto;
}

body.dark-layout {
  .legal-page {
    background: #161d31;
    color: #d0d2d6;
  }

  .legal-page .text-muted,
  .legal-document-list__unavailable {
    color: #b4b7bd !important;
  }

  .legal-group-card {
    background: #283046;
    box-shadow: 0 6px 24px rgba(0, 0, 0, 0.28);
  }

  .legal-document-list__item + .legal-document-list__item {
    border-top-color: #3b4253;
  }
}
</style>
